var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c("validation-observer", {
                ref: "AddForm",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var invalid = ref.invalid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.SubmitPayroll($event)
                              },
                            },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Employee*",
                                  "label-for": "employeeId",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Employee",
                                    vid: "employeeId",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "employeeId",
                                                options: _vm.employeeOptions,
                                                "value-field": "id",
                                                "text-field":
                                                  "employeeFullName",
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.payroll.employeeId,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "employeeId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "payroll.employeeId",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Status*",
                                  "label-for": "status",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Status",
                                    vid: "status",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "status",
                                                options: _vm.statusOptions,
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.payroll.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "payroll.status",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Allocation Type*",
                                  "label-for": "allocationType",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Allocation Type",
                                    vid: "allocationType",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "allocationType",
                                                options: _vm.typeOptions,
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.payroll.allocationType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "allocationType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "payroll.allocationType",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Category*",
                                  "label-for": "category",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Category",
                                    vid: "category",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "category",
                                                options: _vm.categoryOptions,
                                                required: "",
                                              },
                                              model: {
                                                value: _vm.payroll.category,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "category",
                                                    $$v
                                                  )
                                                },
                                                expression: "payroll.category",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Amount*",
                                  "label-for": "amount",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Amount",
                                    vid: "amount",
                                    rules: "min_value:0|required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "amount",
                                                type: "number",
                                                step: "0.01",
                                                required: "",
                                              },
                                              on: { input: _vm.checkNegative },
                                              model: {
                                                value: _vm.payroll.amount,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "amount",
                                                    $$v
                                                  )
                                                },
                                                expression: "payroll.amount",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Allocation Date",
                                  "label-for": "allocationDate",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Allocation Date",
                                    vid: "allocationDate",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-select", {
                                              attrs: {
                                                id: "allocationDate",
                                                options: _vm.allocationDate,
                                                required: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.payroll.allocationDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.payroll,
                                                    "allocationDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "payroll.allocationDate",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: "Notes", "label-for": "notes" },
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: { id: "notes" },
                                  model: {
                                    value: _vm.payroll.notes,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.payroll, "notes", $$v)
                                    },
                                    expression: "payroll.notes",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              { attrs: { "label-for": "isRecurring" } },
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    attrs: { id: "isRecurring" },
                                    model: {
                                      value: _vm.payroll.isRecurring,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.payroll,
                                          "isRecurring",
                                          $$v
                                        )
                                      },
                                      expression: "payroll.isRecurring",
                                    },
                                  },
                                  [_vm._v(" Is Recurring? ")]
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "modal-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button", block: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.SubmitPayroll()
                                    },
                                  },
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", {
                                        staticClass: "mx-2",
                                        attrs: { small: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v("Save Changes "),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }